/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import { useFormik, Form, FormikProvider } from 'formik';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import { useNavigate, useParams } from 'react-router-dom';
import Divider from '@material-ui/core/Divider';
// material
import { Stack, TextField, IconButton, InputAdornment, Button } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import services from './Service'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AESDecryptionParam } from '../../../helpers/AesEncrypt';
// ----------------------------------------------------------------------

export default function ResetForm(props) {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [userName, setUserName] = useState('');
  //const [roles, setRoles] = useState([]);
  //  const [tokenData, setTokenData] = useState({
  //    group:0,
  //    factory:0
  //  });
  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: false,
    submitButtonName: "Reset"
  });
  const { userID } = useParams();
  const [formData, setFormData] = useState({
    userName: "",
    newPassword: "",
    confirmPassword: ""
  });

  const ResetPasswordSchema = Yup.object().shape({
    userName: Yup.string().required('User name required'),
    newPassword: Yup.string().required('Password is required'),
    confirmPassword: Yup.string().required('Password is required')
  });

  const formik = useFormik({
    initialValues: {
      newPassword: formData.newPassword,
      confirmPassword: formData.confirmPassword,
      userName: formData.userName
    },
    validationSchema: ResetPasswordSchema,
    onSubmit: (values) => {
      ResetPassword(values)
    },
  });

  const handleKeyDown = e => {
    if (e.key === " ") {
      e.preventDefault();
    }
  };

  const [isButtonEnable, setIsButtonEnable] = useState(false);

  useEffect(() => {
    if (formik.values.newPassword != "" && formik.values.confirmPassword != "") {
      setIsButtonEnable(true)
    } else {
      setIsButtonEnable(false)
    }
  }, [formik.values.newPassword, formik.values.confirmPassword]);

  async function ResetPassword(values) {
    if (values.newPassword.length > 5) {
      if (values.newPassword == values.confirmPassword) {
        var res = await services.ResetPassword(values, pageProps.editingID);
        if (res.statusCode === "Success") {
          toast.success("Password Reset Succesfully");
          setTimeout(() => {
            navigate('/dashboard/user');
          }, 3000);

        } else {
          toast.error(res.message);
        }
      }
      else {
        toast.error("New Password and Confirm Password not match.");
      }
    }
    else {
      toast.error("New Password should be at least 6 digits.");
    }
  }
  let decrypted = 0;

  useEffect(() => {
    decrypted = AESDecryptionParam(userID.toString());
    if (decrypted != 0) {
      setPageProps({
        ...pageProps,
        isEdit: true,
        submitButtonName: "Reset",
        editingID: parseInt(decrypted)
      })
      setForEdit(decrypted);
    }

  }, []);

  async function setForEdit(id) {
    let userDetailsRes = await services.getUserByID(id);
    if (userDetailsRes != null) {
      setValues({
        userName: userDetailsRes.userName
      })
      setUserName(userDetailsRes.userName);
    }
  }

  async function resetForm() {
    setValues({
      newPassword: '',
      confirmPassword: '',
      userName: userName
    })
  }

  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  return (
    <FormikProvider value={formik}>
      <ToastContainer
        position="bottom-right"
        pauseOnHover
      />
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={4}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
              fullWidth
              size="small"
              label="User name *"
              value={formik.values.userName}
              disabled={true}
              onChange={formik.handleChange}
              {...getFieldProps('userName')}
              error={Boolean(touched.userName && errors.userName)}
              helperText={touched.userName && errors.userName}
            />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
              fullWidth
              size="small"
              autoComplete="current-password"
              type={showPassword ? 'text' : 'password'}
              value={formik.values.newPassword}
              onChange={formik.handleChange}
              onKeyDown={handleKeyDown}
              label="New Password *"
              {...getFieldProps('newPassword')}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton edge="end" onClick={() => setShowPassword((prev) => !prev)}>
                      <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              error={Boolean(touched.newPassword && errors.newPassword)}
              helperText={touched.newPassword && errors.newPassword}
            />
            <TextField
              fullWidth
              size="small"
              autoComplete="current-password"
              type={showConfirmPassword ? 'text' : 'password'}
              label="Confirm Password *"
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              onKeyDown={handleKeyDown}
              {...getFieldProps('confirmPassword')}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton edge="end" onClick={() => setShowConfirmPassword((prev) => !prev)}>
                      <Icon icon={showConfirmPassword ? eyeFill : eyeOffFill} />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              error={Boolean(touched.confirmPassword && errors.confirmPassword)}
              helperText={touched.confirmPassword && errors.confirmPassword}
            />
          </Stack>
          <Divider variant="middle" />
          {isButtonEnable == true ?
          <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
            <Button
              type="button"
              color='error'
              variant="outlined"
              onClick={() => resetForm()}
            >
              Clear
            </Button>
            <Button
              type="submit"
              color='secondary'
              variant="outlined"
            >
              Reset
            </Button>
          </Stack>: null}
        </Stack>
      </Form>
    </FormikProvider>
  );
}
